import { Mail } from "lucide-react";
import EmailsTab from "@/components/admin/EmailsTab";

export const EmailsPage = () => (
  <div className="space-y-4" data-testid="emails-page">
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 rounded-md bg-primary/10 text-primary inline-flex items-center justify-center">
        <Mail className="h-5 w-5" />
      </div>
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold">Emails automatiques</h1>
        <p className="text-sm text-muted-foreground">
          Configurez l'envoi automatique d'emails clients : PV de fin de chantier, relances d'acompte et de solde.
        </p>
      </div>
    </div>
    <EmailsTab />
  </div>
);

export default EmailsPage;
